import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type FilteredAirlinesWidgetAction = ActionType<typeof actions>;

export enum FilteredAirlinesWidgetActionTypes {
  FETCH_REQUEST = "@FilteredAirlinesWidget/FETCH_REQUEST",
  FETCH_SUCCESS = "@FilteredAirlinesWidget/FETCH_SUCCESS",
  FETCH_ERROR = "@FilteredAirlinesWidget/FETCH_ERROR",
}

export interface FilteredAirlinesWidgetState {
  readonly lastUpdated?: string;
  readonly items: string[];
  readonly isLoading: boolean;
}
